"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldMultipleSubmitController = void 0;
const React = __importStar(require("react"));
const Field_Constant_1 = require("./Field.Constant");
const FieldMultipleSubmitController = ({ classNameSubmit = "", labelSubmit = "Submit", data = "", trigger = () => { }, render = false, }) => {
    const [click, setClick] = React.useState(0);
    React.useEffect(() => {
        try {
            if (click === 1) {
                const x = document.querySelectorAll(`.${Field_Constant_1.TEXT_AUTHOR}-submit`);
                if (x.length > 0) {
                    x.forEach((_, i) => {
                        x[i].click();
                    });
                    setClick(0);
                }
                else {
                    return;
                }
            }
        }
        catch (error) {
            console.error("FieldMultipleSubmitController Effect Count", error);
        }
    }, [click]);
    React.useEffect(() => {
        if (click > 0 && trigger) {
            try {
                const checkType = typeof data;
                if (data !== null && data !== undefined) {
                    if (checkType === "object") {
                        const key = Object === null || Object === void 0 ? void 0 : Object.keys(data);
                        if (key.length > 0) {
                            trigger(data);
                            setClick(0);
                        }
                        else {
                            return;
                        }
                    }
                    else {
                        trigger(data);
                        setClick(0);
                    }
                }
                else {
                    return;
                }
            }
            catch (error) {
                console.error("FieldMultipleSubmitController Effect Trigger", error);
            }
        }
        else {
            return;
        }
    }, [data, trigger]);
    if (render) {
        return (React.createElement(React.Fragment, null, render({
            click: () => {
                if (click === 0) {
                    setClick(1);
                }
                else {
                    return;
                }
            },
        })));
    }
    else {
        return (React.createElement("button", { id: `${Field_Constant_1.TEXT_AUTHOR}-button-submit`, className: `${Field_Constant_1.TEXT_AUTHOR}-multi-submit ${classNameSubmit}`, onClick: () => {
                if (click === 0) {
                    setClick(1);
                }
                else {
                    return;
                }
            } }, labelSubmit));
    }
};
exports.FieldMultipleSubmitController = FieldMultipleSubmitController;
